import React from 'react';
import {
  Container, Typography, Grid, Card, CardContent,
  Box, List, ListItem, ListItemIcon, ListItemText, Paper, Button
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MemoryIcon from '@mui/icons-material/Memory';
import SecurityIcon from '@mui/icons-material/Security';
import SpeedIcon from '@mui/icons-material/Speed';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';

const services = [
  'MacBook screen replacement (Retina & standard)',
  'MacBook battery replacement',
  'Keyboard & butterfly/scissor switch repair',
  'Liquid damage diagnosis and repair',
  'SSD upgrade and data migration',
  'macOS reinstallation and recovery',
  'iMac hardware diagnostics',
  'Mac mini RAM & storage upgrades',
  'Thermal paste replacement & fan repair',
  'Charging port & MagSafe repair',
  'Virus/malware removal',
  'Time Machine backup and restore',
];

const benefits = [
  {
    icon: LaptopMacIcon,
    title: 'Apple Specialist',
    description: 'Experienced with all MacBook, iMac, and Mac mini models',
  },
  {
    icon: SpeedIcon,
    title: 'Fast Turnaround',
    description: 'Most Mac repairs completed within 24–48 hours',
  },
  {
    icon: SecurityIcon,
    title: 'Data Safety',
    description: 'Full backup verification before any repair begins',
  },
  {
    icon: MemoryIcon,
    title: 'Quality Parts',
    description: 'Premium-grade replacement parts for all Mac models',
  },
];

const models = [
  'MacBook Air (Intel & M-series)',
  'MacBook Pro 13" / 14" / 15" / 16"',
  'iMac 21.5" & 27"',
  'Mac mini (all generations)',
  'Mac Pro',
  'Mac Studio',
];

function MacRepair() {
  return (
    <Box sx={{ py: 6, bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography variant="h2" component="h1" className="gradient-text" sx={{ mb: 3 }}>
            Mac Repair Services
          </Typography>
          <Typography variant="h5" sx={{ color: 'text.secondary', mb: 4 }}>
            Professional repair and upgrade services for all Apple Mac computers
          </Typography>
          <Button
            component={RouterLink}
            to="/booking"
            variant="contained"
            size="large"
            sx={{
              py: 2, px: 4, fontSize: '1.1rem',
              background: 'linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%)',
              color: '#2d3436', fontWeight: 700,
              '&:hover': {
                background: 'linear-gradient(135deg, var(--primary) 20%, var(--secondary) 80%)',
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 20px rgba(255,107,107,0.3)',
              },
            }}
          >
            Book Mac Repair
          </Button>
        </Box>

        {/* Benefits */}
        <Grid container spacing={4} sx={{ mb: 8 }}>
          {benefits.map((benefit, i) => (
            <Grid item xs={12} sm={6} md={3} key={i}>
              <Card className="glass-effect card-hover" sx={{ height: '100%' }}>
                <CardContent sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <Box sx={{ mb: 2, color: 'primary.main' }}>
                    {React.createElement(benefit.icon, { sx: { fontSize: 40 } })}
                  </Box>
                  <Typography variant="h6" gutterBottom>{benefit.title}</Typography>
                  <Typography variant="body2" color="text.secondary">{benefit.description}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Services */}
        <Paper elevation={3} sx={{ p: 4, mb: 8, background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(10px)' }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>Our Mac Repair Services</Typography>
          <Grid container spacing={2}>
            {services.map((service, i) => (
              <Grid item xs={12} sm={6} key={i}>
                <List>
                  <ListItem>
                    <ListItemIcon><CheckCircleIcon color="primary" /></ListItemIcon>
                    <ListItemText primary={service} />
                  </ListItem>
                </List>
              </Grid>
            ))}
          </Grid>
        </Paper>

        {/* Models */}
        <Paper elevation={3} sx={{ p: 4, background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(10px)' }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>Mac Models We Service</Typography>
          <Grid container spacing={2}>
            {models.map((model, i) => (
              <Grid item xs={12} sm={6} md={4} key={i}>
                <Card className="glass-effect" sx={{ textAlign: 'center', py: 2 }}>
                  <Typography variant="h6">{model}</Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
}

export default MacRepair;
